@if (icon) {
    <i class="icon bf-icon bf-icon-{{ icon | lowercase }}"></i>
}
